import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;

const getCSRF = () => {
    const cookie = document.cookie
    .split('; ')
    .find(row => row.startsWith('XSRF-TOKEN='));
    
    return cookie ?
        decodeURIComponent(cookie.split('=')[1]) : // Decrypt cookie value
        document.querySelector('meta[name="csrf-token"]')?.content; // Fallback
};

const getDynamicCsrfToken = () => {
    return document.querySelector('meta[name="csrf-token"]')?.content || '';
};

const echoConfig = {
    broadcaster: 'reverb',
    key: import.meta.env.VITE_REVERB_APP_KEY,
    wsHost: import.meta.env.VITE_REVERB_HOST,
    wsPort: import.meta.env.VITE_REVERB_PORT ?? 80,
    wssPort: import.meta.env.VITE_REVERB_PORT ?? 443,
    forceTLS: (import.meta.env.VITE_REVERB_SCHEME ?? 'https') === 'https',
    enabledTransports: ['wss', 'ws'],
    withCredentials: true
};
let echo  = new Echo(echoConfig);

let socketId = null;
echo.connector.pusher.connection.bind('connected', () => {
    socketId = echo.socketId();
});

window.Echo = echo;
export default echo;
